import BoxShipAnimation from '@assets/lottie/box_ship.json';
import i18n from '@/utils/i18n';
import React from 'react';
import { AnimationView } from '@usepepper/ui/atoms/animation-view';
import { createStyles } from '@/contexts/theme-context';
import { Typography, YStack } from '@usepepper/sprout-kit-ui';

const ANIMATION_ASPECT_RATIO = 374 / 244;

interface OrderEntryMobileOrderPlacedProps {
  restaurantName: string;
}

export const OrderEntryMobileOrderPlaced: React.FC<
  OrderEntryMobileOrderPlacedProps
> = ({ restaurantName }) => {
  const [styles, theme] = useStyles();

  return (
    <YStack alignItems="center" gap="$16" width="100%">
      <YStack
        backgroundColor={theme.sk.color.bg.highlight.success}
        borderRadius={theme.sk.radii.radiusMedium}
        overflow="hidden"
        width="100%"
      >
        <AnimationView
          autoPlay
          loop
          source={BoxShipAnimation}
          style={styles.animation}
        />
      </YStack>
      <YStack gap="$8" width="100%">
        <Typography size="$md" variant="heading">
          {i18n.t('sales_portal.order_entry.order_placed_modal.title')}
        </Typography>
        <Typography color={theme.sk.color.text.secondary} size="$md">
          {i18n.t('sales_portal.order_entry.order_placed_modal.description', {
            restaurantName,
          })}
        </Typography>
      </YStack>
    </YStack>
  );
};

const useStyles = createStyles(() => ({
  animation: {
    alignSelf: 'center',
    aspectRatio: ANIMATION_ASPECT_RATIO,
    width: '100%',
  },
}));
